import { render, staticRenderFns } from "./DailyContent.vue?vue&type=template&id=6f5ac634&scoped=true"
import script from "./DailyContent.vue?vue&type=script&lang=js"
export * from "./DailyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5ac634",
  null
  
)

export default component.exports